import React from 'react'

export const BuyCredits = () => {
    return (
        <div className="buy-credits">
            Buy Credits Here
        </div>
    )
}
